import { ReactNode, useEffect, useState } from 'react'
import { ThemeContext } from './ThemeContext'

const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('app-theme') || 'light'
  }
  return 'light'
}

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState(getInitialTheme)

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme)
    localStorage.setItem('app-theme', theme)
  }, [theme])

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}
